import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";

const initialState = {
    users: [],
    podcasts: []
};

const endpoint = process.env.NEXT_PUBLIC_BASE_URL
const version = process.env.NEXT_PUBLIC_URL_VERSION

export const searchQuery = createAsyncThunk(
    "searchSlice/searchQuery",
    async ({ search, token, setLoading }) => {
        try {
            setLoading(true);
            const data = await axios.get(`${endpoint}${version}/public/user/search?search=${search}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            console.log(data?.data, 'data from search query')
            return data.data
        } catch (error) {
            toast.error("Failed to fetch", { duration: 2000 });
            return console.error(error.message);
        } finally {
            setLoading(false);
        }
    }
);

const searchSlice = createSlice({
    name: "search",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(searchQuery.fulfilled, (state, action) => {
            state.users = action.payload.users || [];
            state.podcasts = action.payload.podcasts || [];
        })
    }
});

// export const { setUserInfo } = followSlice.actions;
export default searchSlice.reducer;
